import React from 'react';
import styles from './Button.module.css';

const Button = ({
    children,
    variant = 'secondary', // primary, success, danger, secondary
    size = 'md', // sm, md, lg
    isActive = false,
    isDanger = false, // For danger variant styling
    className = '',
    ...props
}) => {
    const buttonClasses = [
        styles.button,
        styles[variant],
        styles[size],
        isActive ? styles.active : '',
        isDanger ? styles.danger : '', // Apply danger specific styles if needed
        className,
    ].join(' ');

    return (
        <button className={buttonClasses} {...props}>
            {children}
        </button>
    );
};

export default Button;